import React, { useEffect } from 'react';

interface SnackbarProps {
    message: string;
    type: 'success' | 'error';
    onClose: () => void;
    duration?: number;
}

const Snackbar: React.FC<SnackbarProps> = ({ message, type, onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [onClose, duration]);

    const bgColor = type === 'success' ? 'bg-gradient-to-r from-cyan-500 to-blue-500' : 'bg-red-500';
    const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle';

    return (
        <div className={`fixed top-4 right-4 z-50 flex items-center gap-3 px-6 py-3 rounded-lg shadow-lg text-white ${bgColor} transform transition-all animate-fade-in-down`}>
            <i className={`fa-solid ${icon} text-lg`}></i>
            <span className="font-medium">{message}</span>
            <button onClick={onClose} className="ml-2 hover:text-white/80 transition-colors">
                <i className="fa-solid fa-times"></i>
            </button>
        </div>
    );
};

export default Snackbar;
